module.exports = __webpack_public_path__ + "img/Lkw_Banner_LoginSeite.ac5a6097.webp";